import React from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage , reportAnalytics} from '../TechnicianUpdatesBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import FailureScreen from '../../../Shared/FailureScreen/FailureScreen';
import '../Shared/ErrorPage/errorPage.scss';

const ErrorPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    props.hideAppLoader(); 

    if (runSideEffects()) {
    }
  }, []);

  function handleErrorPageClose(){
    switch(props.error.id){
      case 1078: //Visits not found
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_2", eventLabel: "element_1"});
        props.context.navigateTo(props.epiContent[props.startPageId].content.personalNavigationLink.value.url);
        break
      case 1075: //Get Visits - general error
        props.goToPage("customerVisitInfoPage");
        break;
      case 1076: //Get timeSlots - general error
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_3", eventLabel: "element_3"});
        props.goToPage("customerVisitInfoPage");
        break;
      case 1077: //Action (cancel visit) -  General error
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_12", eventLabel: "element_14"});
        props.goToPage("customerVisitInfoPage");
        break;
    }
  }
 
  return (
    <div className='technician-update-error-page'>
        <FailureScreen errorId={props.error.id} onclick={handleErrorPageClose}  />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    error : state.technicianUpdatesBlock.error,
    epiContent: state.iContentRepo.items,
    startPageId: state.iContentRepo.website.contentRoots.startPage.id

  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  showAppLoader, 
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
